module.exports = __webpack_public_path__ + "img/body-1-lg.48ed0e9a.png";